export var FactorRequestInclude = {
    logEntry: true,
    unit: true,
    emissionFactor: true,
    activityDataSource: true,
    supplier: true,
    territory: true,
    product: true,
    requester: { include: { photo: true } },
    organization: { include: { logo: true } },
    productLifecycleSteps: true,
};
//# sourceMappingURL=FactorRequest.js.map